/**
 * Words the Emoji Text Generator can turn into an emoji, as `word|code points`.
 *
 * Each emoji was looked up by its Unicode short name in the Emoji 18.0 data, and the test
 * suite checks every row against `public/data/emoji.txt`, so a row cannot name an emoji
 * that does not exist or leave off a required variation selector. Words are matched in
 * lower case; the tool also tries the singular of a plural.
 */
export const EMOJI_WORD_ROWS: readonly string[] = [
  "love|2764.FE0F",
  "heart|2764.FE0F",
  "like|1F44D",
  "yes|2705",
  "no|274C",
  "ok|1F197",
  "cool|1F60E",
  "happy|1F600",
  "smile|1F60A",
  "sad|1F622",
  "cry|1F62D",
  "laugh|1F602",
  "lol|1F602",
  "angry|1F621",
  "mad|1F620",
  "sleep|1F634",
  "tired|1F971",
  "think|1F914",
  "wow|1F632",
  "kiss|1F618",
  "hug|1F917",
  "sick|1F912",
  "party|1F389",
  "celebrate|1F973",
  "congratulations|1F389",
  "birthday|1F382",
  "cake|1F382",
  "gift|1F381",
  "present|1F381",
  "christmas|1F384",
  "santa|1F385",
  "snow|2744.FE0F",
  "snowman|2603.FE0F",
  "halloween|1F383",
  "ghost|1F47B",
  "fire|1F525",
  "hot|1F975",
  "cold|1F976",
  "water|1F4A7",
  "rain|1F327.FE0F",
  "sun|2600.FE0F",
  "moon|1F319",
  "star|2B50",
  "rainbow|1F308",
  "cloud|2601.FE0F",
  "storm|26C8.FE0F",
  "lightning|26A1",
  "wind|1F32C.FE0F",
  "earth|1F30D",
  "world|1F30D",
  "tree|1F333",
  "flower|1F338",
  "rose|1F339",
  "plant|1F331",
  "leaf|1F343",
  "dog|1F436",
  "cat|1F431",
  "mouse|1F42D",
  "cow|1F42E",
  "pig|1F437",
  "frog|1F438",
  "monkey|1F435",
  "chicken|1F414",
  "bird|1F426",
  "penguin|1F427",
  "fish|1F41F",
  "whale|1F433",
  "dolphin|1F42C",
  "octopus|1F419",
  "turtle|1F422",
  "snake|1F40D",
  "bee|1F41D",
  "butterfly|1F98B",
  "bug|1F41B",
  "spider|1F577.FE0F",
  "lion|1F981",
  "tiger|1F42F",
  "bear|1F43B",
  "panda|1F43C",
  "rabbit|1F430",
  "fox|1F98A",
  "wolf|1F43A",
  "horse|1F434",
  "unicorn|1F984",
  "elephant|1F418",
  "giraffe|1F992",
  "shark|1F988",
  "owl|1F989",
  "duck|1F986",
  "sheep|1F411",
  "koala|1F428",
  "pizza|1F355",
  "burger|1F354",
  "fries|1F35F",
  "hotdog|1F32D",
  "taco|1F32E",
  "burrito|1F32F",
  "sushi|1F363",
  "ramen|1F35C",
  "rice|1F35A",
  "bread|1F35E",
  "cheese|1F9C0",
  "egg|1F95A",
  "bacon|1F953",
  "apple|1F34E",
  "banana|1F34C",
  "orange|1F34A",
  "lemon|1F34B",
  "strawberry|1F353",
  "cherry|1F352",
  "grape|1F347",
  "watermelon|1F349",
  "pineapple|1F34D",
  "peach|1F351",
  "avocado|1F951",
  "carrot|1F955",
  "corn|1F33D",
  "tomato|1F345",
  "potato|1F954",
  "coffee|2615",
  "tea|1F375",
  "beer|1F37A",
  "wine|1F377",
  "milk|1F95B",
  "cookie|1F36A",
  "donut|1F369",
  "icecream|1F368",
  "candy|1F36C",
  "chocolate|1F36B",
  "popcorn|1F37F",
  "phone|1F4F1",
  "computer|1F4BB",
  "keyboard|2328.FE0F",
  "book|1F4D6",
  "books|1F4DA",
  "pen|1F58A.FE0F",
  "pencil|270F.FE0F",
  "paper|1F4C4",
  "mail|2709.FE0F",
  "email|1F4E7",
  "letter|2709.FE0F",
  "key|1F511",
  "lock|1F512",
  "light|1F4A1",
  "idea|1F4A1",
  "clock|23F0",
  "money|1F4B0",
  "dollar|1F4B5",
  "camera|1F4F7",
  "music|1F3B5",
  "guitar|1F3B8",
  "piano|1F3B9",
  "drum|1F941",
  "headphones|1F3A7",
  "movie|1F3AC",
  "tv|1F4FA",
  "game|1F3AE",
  "trophy|1F3C6",
  "medal|1F3C5",
  "ball|26BD",
  "soccer|26BD",
  "basketball|1F3C0",
  "football|1F3C8",
  "baseball|26BE",
  "tennis|1F3BE",
  "bike|1F6B2",
  "car|1F697",
  "bus|1F68C",
  "train|1F686",
  "plane|2708.FE0F",
  "airplane|2708.FE0F",
  "rocket|1F680",
  "ship|1F6A2",
  "boat|26F5",
  "house|1F3E0",
  "home|1F3E0",
  "school|1F3EB",
  "hospital|1F3E5",
  "castle|1F3F0",
  "city|1F3D9.FE0F",
  "mountain|26F0.FE0F",
  "beach|1F3D6.FE0F",
  "island|1F3DD.FE0F",
  "tent|26FA",
  "science|1F52C",
  "telescope|1F52D",
  "microscope|1F52C",
  "teacher|1F9D1.200D.1F3EB",
  "student|1F9D1.200D.1F393",
  "graduate|1F393",
  "homework|1F4DD",
  "test|1F4DD",
  "study|1F4DA",
  "brain|1F9E0",
  "atom|269B.FE0F",
  "dna|1F9EC",
  "robot|1F916",
  "alien|1F47D",
  "hello|1F44B",
  "hi|1F44B",
  "bye|1F44B",
  "thanks|1F64F",
  "please|1F64F",
  "pray|1F64F",
  "clap|1F44F",
  "strong|1F4AA",
  "peace|270C.FE0F",
  "fist|270A",
  "eyes|1F440",
  "ear|1F442",
  "baby|1F476",
  "boy|1F466",
  "girl|1F467",
  "man|1F468",
  "woman|1F469",
  "family|1F46A",
  "king|1F451",
  "queen|1F451",
  "crown|1F451",
  "princess|1F478",
  "wizard|1F9D9",
  "devil|1F608",
  "angel|1F607",
  "skull|1F480",
  "warning|26A0.FE0F",
  "stop|1F6D1",
  "question|2753",
  "exclamation|2757",
  "hundred|1F4AF",
  "new|1F195",
  "free|1F193",
  "sos|1F198",
  "up|2B06.FE0F",
  "down|2B07.FE0F",
  "right|27A1.FE0F",
  "left|2B05.FE0F",
  "infinity|267E.FE0F",
  "recycle|267B.FE0F",
  "red|1F534",
  "blue|1F535",
  "green|1F7E2",
  "yellow|1F7E1",
  "purple|1F7E3",
  "black|26AB",
  "white|26AA",
  "brown|1F7E4",
  "night|1F303",
  "morning|1F305",
  "autumn|1F342",
  "winter|2744.FE0F",
  "summer|2600.FE0F",
  "spring|1F338",
];
